<template>
  <el-input-number
    v-model="value"
    :min="0.1"
    :max="10"
    :step="0.1"
    :controls="false"
    :disabled="disabled"
    @update:modelValue="input"
  />
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'SkipOffsetInput',
  props: {
    modelValue: {
      type: [Number, String],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const input = (newValue: number) => {
      context.emit('update:modelValue', newValue)
    }

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { input, value }
  }
})
</script>
